export default function LocationBand() {
  return (
    <div className="relative bg-ds-bg-2 border-t border-ds-border overflow-hidden">
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-ds-red/25 to-transparent" />
      <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col sm:flex-row items-center justify-center gap-3 text-center">
        <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
          <i className="ri-map-pin-2-line text-ds-red text-sm" />
        </div>
        <p className="font-body text-white/45 text-xs sm:text-sm leading-relaxed">
          <strong className="text-white/75 font-600">Proudly based in Mission Beach, Queensland.</strong>
          {' '}Serving local businesses across the Cassowary Coast, Far North QLD, Cairns, Townsville, and all of Australia.
        </p>
      </div>
    </div>
  );
}
